/* eslint-disable camelcase */

import moduleTemplate from './moduleTemplate'
import companiesAPI from '@/api/companies'

export default moduleTemplate(companiesAPI)
